import React from 'react'
import classNames from 'classnames'
import ActionMenu from 'components/ActionMenu'

const ChipDropdownItem = ({ row, disabled, onItemClick, setShowMenu, labelCapitalize, isSearchable }) => {

  const onClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (!disabled) {
      onItemClick(row.value, row)
      setShowMenu(false)
    }
  }

  const dotClassName = classNames(
    'viso-chip-dropdown-indicator__dot',
    row.color && `viso-bg-${row.color}`
  )

  return (
    (row.icon || isSearchable) ?
      <ActionMenu
        onClick={onClick}
        icon={row.icon}
        text={row.label}
        badge={row.badge}
      />
      :
      <div
        className={
          classNames('viso-chip-dropdown-item', {
            'viso-chip-dropdown-item--disabled': disabled,
            'text-capitalize': labelCapitalize
          })}
        onClick={disabled
          ? (e) => {
            e.stopPropagation()
            e.preventDefault()
          }
          : onClick}
      >
        <div className='viso-chip-dropdown-item__container'>

          <div className='viso-chip-dropdown-indicator'>
            <div
              className={dotClassName}
              style={{ background: row.colour }}
            />
            {row.label}
          </div>
        </div>
      </div>
  )
}

export default ChipDropdownItem